(function($){
  $(document).ready(function(){
    var cartcounterCreation = false;
    $(document).on('keyup', '.gs__field-input', function() {
        var maxLimit = 250,
        totalCharCount = 0,
        charRemaining = 0,
        toFieldCount = 0,
        toFieldLimit = 0,
        fromFieldCount = 0,
        fromFieldLimit = 0,
        msgFieldCount = 0,
        msgFieldLimit = 0,
        toFieldId = 'RecipientName',
        fromFieldId = 'SenderName',
        msgFieldId = 'GiftMessage';

      //Keeps track of changes in all fields and updates total and remaining counter as well as specific field counter
      $.each($('.gs__field-input'), function(){
        totalCharCount += $(this).val().length;
        charRemaining = maxLimit - totalCharCount;

        if($(this).attr('id') === toFieldId) {
          toFieldCount = $(this).val().length;
        }

        if($(this).attr('id') === fromFieldId) {
          fromFieldCount = $(this).val().length;
        }

        if($(this).attr('id') === msgFieldId) {
          msgFieldCount = $(this).val().length;
        }
      });

      //Calculates each field limit based on the current text content
      toFieldLimit = toFieldCount + charRemaining;
      fromFieldLimit = fromFieldCount + charRemaining;
      msgFieldLimit = msgFieldCount + charRemaining;

      //Sets updated max length to all fields after latest keyup count
      $('#' + toFieldId).attr('maxlength', toFieldLimit);
      $('#' + fromFieldId).attr('maxlength', fromFieldLimit);
      $('#' + msgFieldId).attr('maxlength', msgFieldLimit);

      if(!cartcounterCreation) { //First keyup counter creation
        $('.field.gs__message').prepend('<span class="char-counter">You have <span class="char-count">'+charRemaining+'</span> characters remaining </span>');
        cartcounterCreation = true;
      } else { //Count update upon keyup
        $('.char-count').text(charRemaining);
      }
      $('.char-counter').show();
})
  });
})(jQuery);